/**
 * 4.3.11 walkthrough slides.
 *
 * Each slide:
 *   {
 *     image:          public-path string (e.g. '/walkthroughs/4.3.11/foo.png'),
 *     title:          short heading,
 *     body:           one or two sentences describing the change,
 *     minRoleWeight?: integer — only users with role_weight >= this see the slide
 *                     (matches hasMinRole gating; omit for "visible to everyone")
 *     is_cloud_only?: boolean — true hides the slide on 4.0 campuses, for features
 *                     that only exist on the 5.0 cloud architecture. Omitted or
 *                     false means architecture-independent. Evaluated against the
 *                     campus config's `is_cloud` in collectSlides (index.js).
 *     is_grandstream?: boolean — true shows the slide only on Grandstream (intercom)
 *                     campuses, the same check that shows the Call Logs report.
 *     is_ehr_integration?: boolean — true shows the slide only where the EHR Tasks
 *                     page, and its History tab, is available (see index.js).
 *   }
 *
 * Drop walkthrough images under public/walkthroughs/{version}/.
 */
export default [
  {
    image: '/walkthroughs/4.3.11/slide1.png',
    title: 'Enhanced Call Logs',
    body: 'Every call placed from PalCare Mobile now shows how it ended: Answered, No answer, Busy, Failed, or Not placed, and why. Talk time now starts when the call is answered, so you can see how long your caregivers actually spent talking with a resident. You will find this on the Call Logs report, now with an Answer Rate, on the Event page, and in scheduled reports.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: true,
    is_grandstream: true
  },{
    image: '/walkthroughs/4.3.11/slide2.png',
    title: 'EHR Tasks Updated',
    body: 'Resident information updates from your EHR, such as a new phone number or email, are now approved automatically. You will find them in the History tab, and they no longer count toward your EHR Tasks badge, so the Update Resident Info tab has been removed. Every task that still needs a decision now has a Review button, so it is clear where to approve or reject it.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false,
    is_ehr_integration: true
  }
];
